import React, { useState } from 'react'
import { ChevronLeft, ChevronRight, Expand } from 'lucide-react'
import Lightbox from '../../components/Lightbox'

const MOCK_CABINS = [
  {
    name: 'Deluxe Cabin',
    count: 12,
    location: 'Main Deck',
    size: '26 m²',
    capacity: '2 guests',
    images: [],
    extras: ['Ocean view window', 'En-suite bathroom', 'Air conditioning', 'Mini bar', 'Daily housekeeping'],
  },
  {
    name: 'Premium Suite',
    count: 8,
    location: 'Upper Deck',
    size: '36 m²',
    capacity: '2 guests',
    images: [],
    extras: ['Private balcony', 'Bathtub & rain shower', 'Sitting area', 'Pillow menu', 'Complimentary minibar'],
  },
  {
    name: "Owner's Suite",
    count: 2,
    location: 'Sun Deck',
    size: '58 m²',
    capacity: '2–3 guests',
    images: [],
    extras: ['Wraparound terrace', 'Soaking tub with bay view', 'Separate living room', 'Butler service', 'Priority excursion booking'],
  },
]


function CabinGallery({ images, name }) {
  const [idx, setIdx]         = useState(0)
  const [lightbox, setLightbox] = useState(false)

  if (!images?.length) {
    return (
      <div className="sc-cabin-gallery">
        <div className="sc-cabin-gallery__empty">No images yet</div>
      </div>
    )
  }

  const prev = e => { e.stopPropagation(); setIdx(i => (i - 1 + images.length) % images.length) }
  const next = e => { e.stopPropagation(); setIdx(i => (i + 1) % images.length) }

  return (
    <>
      <div className="sc-cabin-gallery">
        <img
          src={images[idx]}
          alt={`${name} ${idx + 1}`}
          className="sc-cabin-gallery__img"
          onClick={() => setLightbox(true)}
          style={{ cursor: 'zoom-in' }}
        />

        <button className="sc-cabin-gallery__expand" onClick={() => setLightbox(true)} title="View all photos" aria-label="View all photos">
          <Expand size={14} />
          <span>{images.length} photos</span>
        </button>

        {images.length > 1 && (
          <>
            <div className="sc-cabin-gallery__nav">
              <button className="sc-cabin-gallery__btn" onClick={prev} aria-label="Previous"><ChevronLeft size={16} /></button>
              <button className="sc-cabin-gallery__btn" onClick={next} aria-label="Next"><ChevronRight size={16} /></button>
            </div>
            <div className="sc-cabin-gallery__dots">
              {images.map((_, i) => (
                <div key={i} className={`sc-cabin-gallery__dot ${i === idx ? 'sc-cabin-gallery__dot--active' : ''}`} />
              ))}
            </div>
          </>
        )}
      </div>

      {lightbox && (
        <Lightbox images={images} startIdx={idx} caption={name} onClose={() => setLightbox(false)} />
      )}
    </>
  )
}

function CabinCard({ cabin }) {
  return (
    <div className="sc-cabin-card">
      <div className="sc-cabin-card__inner">
        <CabinGallery images={cabin.images} name={cabin.name} />

        <div className="sc-cabin-info">
          <div className="sc-cabin-info__name">{cabin.name}</div>
          <div className="sc-cabin-info__count">
            {cabin.count}
          </div>

          <div className="sc-cabin-specs">
            <div className="sc-cabin-spec">
              <span className="sc-cabin-spec__label">Location</span>
              <span className="sc-cabin-spec__value">{cabin.location}</span>
            </div>
            <div className="sc-cabin-spec">
              <span className="sc-cabin-spec__label">Size</span>
              <span className="sc-cabin-spec__value">{cabin.size}</span>
            </div>
            <div className="sc-cabin-spec">
              <span className="sc-cabin-spec__label">Capacity</span>
              <span className="sc-cabin-spec__value">{cabin.capacity}</span>
            </div>
          </div>

          {cabin.extras?.length > 0 && (
            <div className="sc-cabin-extras">
              {cabin.extras.map(e => (
                <span key={e} className="sc-cabin-extra-tag">{e}</span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

function normalizeCabin(cabin) {
  return {
    ...cabin,
    extras: (cabin.extras || []).map(e => (typeof e === 'object' ? e.item : e)).filter(Boolean),
  }
}

export default function Cabins({ cabins, headingHidden }) {
  const items = (cabins?.length ? cabins : MOCK_CABINS).map(normalizeCabin)

  return (
    <div>
      {!headingHidden && <h2 className="ljn-section-title">Suites & Cabins</h2>}
      <div className="sc-cabins">
        {items.map((cabin, i) => <CabinCard key={i} cabin={cabin} />)}
      </div>
    </div>
  )
}
